var documentHead = function () {
    return document.querySelector('head') ||
        (function () {
            var h = document.createElement('head');
            return document.appendChild(h);
        })();
};
var ResolutionStrategy;
(function (ResolutionStrategy) {
    ResolutionStrategy[ResolutionStrategy["IMMEDIATELY"] = 0] = "IMMEDIATELY";
    ResolutionStrategy[ResolutionStrategy["ON_LOAD_EVENT"] = 1] = "ON_LOAD_EVENT";
})(ResolutionStrategy || (ResolutionStrategy = {}));
var loadScript = function (src, loadIntoHead, scriptId, resolution, timeoutDuration
// eslint-disable-next-line max-params
) {
    if (scriptId === void 0) { scriptId = 'temp-script'; }
    if (resolution === void 0) { resolution = ResolutionStrategy.ON_LOAD_EVENT; }
    if (timeoutDuration === void 0) { timeoutDuration = undefined; }
    var scriptPromise = new Promise(function (resolve, reject) {
        if (typeof document === 'undefined') {
            reject(new Error('document is not defined'));
        }
        else {
            var prev = document.getElementById(scriptId);
            if (prev) {
                prev.remove();
            }
            var script_1 = document.createElement('script');
            script_1.setAttribute('type', 'text/javascript');
            script_1.setAttribute('id', scriptId);
            script_1.setAttribute('src', src);
            script_1.async = true;
            script_1.defer = true;
            if (resolution === ResolutionStrategy.ON_LOAD_EVENT) {
                script_1.onload = function () {
                    resolve();
                };
            }
            var appendTarget_1 = loadIntoHead ? documentHead() : document.body;
            var onScriptLoadError = function () {
                appendTarget_1.removeChild(script_1);
                if (resolution === ResolutionStrategy.IMMEDIATELY) {
                    console.error("Failed to load ".concat(src));
                }
                else {
                    reject(new Error("Failed to load ".concat(src)));
                }
            };
            script_1.addEventListener('error', onScriptLoadError);
            appendTarget_1.appendChild(script_1);
            if (resolution === ResolutionStrategy.IMMEDIATELY) {
                resolve();
            }
        }
    });
    if (timeoutDuration) {
        var timeoutPromise = new Promise(function (resolve, reject) {
            setTimeout(function () {
                reject(new Error('Timeout: Map API initialization took too long'));
            }, timeoutDuration);
        });
        return Promise.race([scriptPromise, timeoutPromise]);
    }
    return scriptPromise;
};
var checkScriptIsLoaded = function (scriptName, checkApiIsLoaded, checkApiIsLoading, retry) {
    return new Promise(function (resolve, reject) {
        var delay = retry.delay, maxRetries = retry.maxRetries, retriesLeft = retry.retriesLeft;
        var apiIsLoaded = checkApiIsLoaded();
        var apiIsLoading = checkApiIsLoading();
        if (apiIsLoaded)
            resolve(true);
        if (!apiIsLoading)
            reject(new Error("".concat(scriptName, " is not loaded")));
        var count = retriesLeft !== null && retriesLeft !== void 0 ? retriesLeft : maxRetries;
        if (count > 0) {
            setTimeout(function () {
                return checkScriptIsLoaded(scriptName, checkApiIsLoaded, checkApiIsLoading, {
                    delay: delay,
                    maxRetries: maxRetries,
                    retriesLeft: count - 1
                })
                    .then(resolve)
                    .catch(reject);
            }, delay);
        }
        else
            reject(new Error("".concat(scriptName, " was not detected as loaded after ").concat(delay * maxRetries, "ms")));
    });
};
var ScriptLoader = /** @class */ (function () {
    function ScriptLoader() {
    }
    ScriptLoader.getScript = function (url, loadIntoHead, loadScriptFn) {
        if (loadScriptFn === void 0) { loadScriptFn = loadScript; }
        return loadScriptFn(url, loadIntoHead).then(function () { return true; });
    };
    return ScriptLoader;
}());

export { ResolutionStrategy, ScriptLoader, checkScriptIsLoaded, documentHead, loadScript };
